module.exports = __webpack_public_path__ + "static/media/notification_icon.bef21b1c.svg";